import(/* webpackMode: "eager" */ "/app/src/app/[locale]/legal/page.tsx");
